/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import { Map as ImmutableMap } from 'immutable';
import { denormalize } from 'normalizr';
import * as schemas from 'data/utils/schemas';
import {
  itemsPagination,
  listLoadingProgress,
  loadingProgress,
  createLoadingProgress,
  updateLoadingProgress,
  addSiteLoadingProgress,
  removeSiteLoadingProgress,
} from 'data/reducers/admin/companies';

import createImmutableEqualSelector from '../../utils/immutable-selector';

const getState = (state: any) => state.adminCompanies;

export const getEntities = (state: any) => getState(state).get('entities');
export const getItem = (state: any, id: string | number) =>
  getEntities(state).get(String(id)) || getEntities(state).get(id);
export const getCurrentCompanyId = (state: any) => getState(state).get('currentCompanyId');

export const getCurrentItem = createImmutableEqualSelector(
  getEntities,
  getCurrentCompanyId,
  (companies, currentCompanyId) =>
    currentCompanyId ? denormalize(currentCompanyId, schemas.company, ImmutableMap({ companies })) : null,
);

export const getItemsList = createImmutableEqualSelector(getEntities, getState, (companies, state) =>
  denormalize(itemsPagination.getPageItems(state), [schemas.company], ImmutableMap({ companies })),
);

export const getItemsTotal = (state: any) => itemsPagination.getTotalItems(getState(state));
export const getItemsPerPage = (state: any) => itemsPagination.getItemsPerPage(getState(state));

export const getItemsListLoaded = (state: any) => listLoadingProgress.getLoaded(getState(state));
export const getItemsListLoading = (state: any) => listLoadingProgress.getLoading(getState(state));
export const getItemsListLoadFailed = (state: any) => listLoadingProgress.getLoadFailed(getState(state));

export const getItemLoaded = (state: any) => loadingProgress.getLoaded(getState(state));
export const getItemLoading = (state: any) => loadingProgress.getLoading(getState(state));
export const getItemLoadFailed = (state: any) => loadingProgress.getLoadFailed(getState(state));

export const getCreateLoaded = (state: any) => createLoadingProgress.getLoaded(getState(state));
export const getCreateLoading = (state: any) => createLoadingProgress.getLoading(getState(state));
export const getCreateLoadFailed = (state: any) => createLoadingProgress.getLoadFailed(getState(state));

export const getUpdateLoaded = (state: any) => updateLoadingProgress.getLoaded(getState(state));
export const getUpdateLoading = (state: any) => updateLoadingProgress.getLoading(getState(state));
export const getUpdateLoadFailed = (state: any) => updateLoadingProgress.getLoadFailed(getState(state));

export const getAddSiteLoaded = (state: any) => addSiteLoadingProgress.getLoaded(getState(state));
export const getAddSiteLoading = (state: any) => addSiteLoadingProgress.getLoading(getState(state));
export const getAddSiteLoadFailed = (state: any) => addSiteLoadingProgress.getLoadFailed(getState(state));

export const getRemoveSiteLoaded = (state: any) => removeSiteLoadingProgress.getLoaded(getState(state));
export const getRemoveSiteLoading = (state: any) => removeSiteLoadingProgress.getLoading(getState(state));
export const getRemoveSiteLoadFailed = (state: any) => removeSiteLoadingProgress.getLoadFailed(getState(state));
